"use client";
import type { DbClient } from "@tanstack/db";
import { DbProvider } from "@tanstack/react-db";
import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import {
  QueryRequestContext,
  QueryViewerContext,
} from "./browser-data-context";
export function BrowserDataScopeProvider({
  children,
  scope,
}: PropsWithChildren<{
  readonly scope: {
    readonly key: string;
    readonly viewerId: string;
    readonly elevatedPrivileges: boolean;
    readonly queryClient: QueryClient;
    readonly dbClient: DbClient;
    readonly reportAuthorizationError: (error: Error) => void;
  };
}>) {
  return (
    <QueryViewerContext value={scope.viewerId}>
      <QueryRequestContext
        key={scope.key}
        value={{
          elevatedPrivileges: scope.elevatedPrivileges,
          reportAuthorizationError: scope.reportAuthorizationError,
        }}
      >
        <QueryClientProvider client={scope.queryClient}>
          <DbProvider client={scope.dbClient}>{children}</DbProvider>
        </QueryClientProvider>
      </QueryRequestContext>
    </QueryViewerContext>
  );
}
